import { ReactComponent as BetCreditsSvg } from "../../assets/icons/bet-credits.svg"
import { useInternalization } from "../../context/cms-context"
import { formatMoney } from "../../helpers/currency"
import './bet-credits.css'

// plc-app's AvailableIcons.BET_CREDITS, always in the bonus bets purple so credits read differently from cash
export const BetCreditsIcon = ({ size = 16 }: { size?: number }) => (
  <BetCreditsSvg className="bet_credits__icon" width={size} height={size} aria-label="Bet credits" />
)

// plc-app's CreditsAppliedLabel: the credits icon and "$5 used", shown next to a wager that was part paid with credits
export const CreditsUsedLabel = ({ amount, className = '' }: { amount: number, className?: string }) => {
  const { translate } = useInternalization()
  return (
    <span className={`bet_credits__label pl-fontXS ${className}`}>
      <BetCreditsIcon size={14} />
      {translate('common_phrases-credits_count', { credit_count: formatMoney(amount) })}
    </span>
  )
}

// plc-app marks a payout that came partly as credits with "Includes" and the credits icon
export const IncludesCredits = ({ className = '' }: { className?: string }) => {
  const { translate } = useInternalization()
  return (
    <span className={`bet_credits__includes pl-fontXS ${className}`}>
      {translate('common-phrases_includes')}
      <BetCreditsIcon size={14} />
    </span>
  )
}

// the line under a win amount: game, what was staked in cash (or "Free bet"), any credits used, and whether the
// payout came partly as credits. the same split plc-app's bet details shows
export const WinWagerSummary = ({ gameLabel, plBalance, plCredits, creditsPaidOut, className = '' }: {
  gameLabel: string | null
  plBalance: number
  plCredits: number
  creditsPaidOut: number
  className?: string
}) => {
  const wager = plBalance === 0 && plCredits > 0 ? 'Free bet' : `${formatMoney(plBalance, { alwaysDecimal: true })} wagered`
  return (
    <span className={`bet_credits__summary ${className}`}>
      <span>{[gameLabel, wager].filter(Boolean).join(' · ')}</span>
      {plCredits > 0 && <CreditsUsedLabel amount={plCredits} />}
      {creditsPaidOut > 0 && <IncludesCredits />}
    </span>
  )
}
